var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M9.574 18.669a8.134 8.134 0 1 0 0-16.269 8.134 8.134 0 0 0 0 16.269zm0 1.44a9.574 9.574 0 1 1 0-19.149 9.574 9.574 0 0 1 0 19.149z"}}),_c('path',{attrs:{"d":"M16.119 16.96l.963-1.07 7.064 6.361-.963 1.07z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }